module.exports = __webpack_public_path__ + "static/media/modal-waves-ripples.9c56f0a3.png";